<template>
	<div class="full">
		<el-tabs class="full flex" style="flex-direction: column;" v-model="activeName" type="card">
			<el-tab-pane label="回访记录" name="flowup">
				<div class="pane_container">
					<flowup :row="row"  :key="'flowup_'+key" />
				</div>
			</el-tab-pane>
			<el-tab-pane label="订单" name="order">
				<div class="pane_container">
					<order :row="row"  :key="'order_'+key" />
				</div>
			</el-tab-pane>
			<el-tab-pane label="分配记录" name="distribution">
				<div class="pane_container">
					<distribution :row="row"  :key="'distribution_'+key" />
				</div>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>
<style scoped>
	.pane_container {
		position: relative;
		width: 100%;
		height: 100%;
		box-sizing: border-box;
		padding: 0px;
		overflow-y: auto;
		overflow-x: hidden;
		box-sizing: border-box;
	}
</style>
<script>
	import distribution from './distribution.vue';
	import flowup from './flowup.vue';
	import order from './order.vue';
	export default {
		props: {
			row: {
				type: Object,
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				activeName: 'flowup',
				key: Math.random()
			}
		},
		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			onSubmit() {
				console.distribution('submit!');
			},
			inittab() {
				this.key = Math.random()
			}
		},
		components: {
			distribution,
			flowup,
			order,
		}
	}
</script>
